import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import i18n from './i18n';
import API from './services/api';
import onlyUnique from './helpers/onlyUnique';
import VueCryptojs from 'vue-cryptojs';

Vue.use(VueCryptojs)
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    componentKey: 0,

    brand: null,
    avcNative: null,
    avcLive: null,

    activeStep: 0,

    selectedCategory: null,
    selectedYear: null,
    selectedModel: null,
    selectedColor: null,
    selectedUnit: {},
    selectedUnitCategory: {},

    selectedPart: {}, /* For PriceBox */
    selectedPoint: {}, /* For PriceBox */
    selectedVIN: null,

    availableCategories: [],
    availableYears: [],
    availableModels: [],
    availableColors: [],
    availableUnits: [],
    availableFilteredUnits: [],
    availableUnitsCategories: [],

    parts: [],
    points: []
  },
  getters: {
    getActiveStep: state => {
      return state.activeStep
    }
  },
  mutations: {
    increaseComponentKey: (state) => {
      state.componentKey = state.componentKey + 1;
    },
    setBrand: (state, payload) => {
      state.brand = payload;
    },
    setAvcNative: (state, payload) => {
      state.avcNative = payload;
    },
    setAvcLive: (state, payload) => {
      state.avcLive = payload;
    },
    setBrand: (state, payload) => {
      state.brand = payload;
    },
    /* Selected options */
    setActiveStep: (state, payload) => {
      state.activeStep = payload;
    },
    incrementActiveStep: (state) => {
      state.activeStep++;
    },
    setCategory: (state, payload) => {
      state.selectedCategory = payload;
    },
    setYear: (state, payload) => {
      state.selectedYear = payload;
    },
    setModel: (state, payload) => {
      state.selectedModel = payload;
    },
    setColor: (state, payload) => {
      state.selectedColor = payload;
    },
    setUnit: (state, payload) => {
      state.selectedUnit = payload;
    },
    setPoint: (state, payload) => {
      state.selectedPoint = payload;
    },
    setPart: (state, payload) => {
      state.selectedPart = payload;
    },
    setVIN: (state, payload) => {
      state.selectedVIN = payload;
    },

    /* Available options */
    setCategories: (state, payload) => {
      state.availableCategories = payload.categories;
    },
    setYears: (state, payload) => {
      state.availableYears = payload.years;
    },
    setModels: (state, payload) => {
      state.availableModels = payload.models;
    },
    setColors: (state, payload) => {
      state.availableColors = payload.colors;
    },
    setUnits: (state, payload) => {
      state.availableUnits = payload.units;
    },
    setFilteredUnits: (state, payload) => {
      if (payload.filter == 'Engine') {
        state.selectedUnitCategory = 'Engine';
        state.availableFilteredUnits = state.availableUnits.filter(p => p.category == 'Engine')
      } else if (payload.filter == 'Frame') {
        state.selectedUnitCategory = 'Frame';
        state.availableFilteredUnits = state.availableUnits.filter(p => p.category == 'Frame')
      } else if (payload.filter == 'Other') {
        state.selectedUnitCategory = 'Other';
        state.availableFilteredUnits = state.availableUnits.filter(p => p.category == 'Other')
      } else {
        state.selectedUnitCategory = 'All';
        state.availableFilteredUnits = state.availableUnits;
      }
    },
    setUnitsCategories: (state, payload) => {
      // let availableUnitsCategories = [...new Set(payload.units.map(p => p.category))];
      let availableUnitsCategories = payload.units.map(p => p.category).filter(onlyUnique);
      state.availableUnitsCategories = availableUnitsCategories;
    },

    setParts: (state, payload) => {
      state.parts = payload.parts;
    },
    setPoints: (state, payload) => {
      state.points = payload.points;
    },
  },
  actions: {
    backToCategories(context) {
      if (context.state.activeStep > 0) {
        context.commit('setActiveStep', 0);

        context.commit('setCategory', null);
        context.commit('setModel', null);
        context.commit('setModels', {});
        context.commit('setYear', null);
        context.commit('setYears', {});
        context.commit('setColor', null);
        context.commit('setColors', {});
        context.commit('setUnits', {});
        context.commit('setUnit', {});
        context.commit('setPart', {});
        context.commit('setPoint', {});
        context.commit('setParts', []);
        context.commit('setPoints', []);
      }
    },
    backToModels(context) {
      if (context.state.activeStep > 1) {
        context.commit('setActiveStep', 1);

        context.commit('setModel', null);
        context.commit('setModels', {});
        context.commit('setYear', null);
        context.commit('setColors', {});
        context.commit('setColor', null);
        context.commit('setUnits', {});
        context.commit('setUnit', {});
        context.commit('setPart', {});
        context.commit('setPoint', {});
        context.commit('setParts', []);
        context.commit('setPoints', []);
      }
    },
    backToColors(context) {
      if (context.state.activeStep > 2) {
        context.commit('setActiveStep', 2);

        context.commit('setColor', null);

        context.commit('setUnits', {});
        context.commit('setUnit', {});
        context.commit('setPart', {});
        context.commit('setPoint', {});
        context.commit('setParts', []);
        context.commit('setPoints', []);
      }
    },
    backToUnits(context) {
      if (context.state.activeStep > 3) {
        context.commit('setActiveStep', 3);
        context.commit('setUnit', {});
        context.commit('setPart', {});
        context.commit('setPoint', {});
        context.commit('setParts', []);
        context.commit('setPoints', []);

      }
    },
    goBack(context) {
      switch (context.state.activeStep) {
        case 4:
          context.dispatch('backToUnits');
          break;
        case 3:
          if (context.state.brand == 'ktm' || context.state.brand == 'husky')
            context.dispatch('backToModels');
          else
            context.dispatch('backToColors');
          break;
        case 2:
          context.dispatch('backToModels');
          break;
        case 1:
          context.dispatch('backToCategories');
          break;
      }
    },
    selectCategory: async (context, payload) => {
      context.commit('setCategory', payload.selectedCategory);
      context.commit('incrementActiveStep');
      API.get(`/index.php?action=getYears&brand=${context.state.brand}&category=${context.state.selectedCategory}`)
        .then(response => {
          context.commit('setYears', response.data);
        });
    },
    selectYear: async (context) => {
      API.get(`/index.php?action=getModels&brand=${context.state.brand}&category=${context.state.selectedCategory}&year=${context.state.selectedYear}`)
        .then(response => {
          context.commit('setModels', response.data);
        });
    },
    selectModel: (context) => {
      context.commit('incrementActiveStep');
      API.get(`/index.php?action=getColors&brand=${context.state.brand}&category=${context.state.selectedCategory}&year=${context.state.selectedYear}&model=${context.state.selectedModel}`)
        .then(response => {
          context.commit('setColors', response.data);
          if (response.data.colors.length == 1) {
            context.dispatch('selectColor', { selectedColor: response.data.colors[0].colorName });
          }
        });
    },
    selectColor: async (context, payload) => {
      context.commit('setColor', payload.selectedColor);
      context.commit('incrementActiveStep');
      // let loader = Vue.$loading.show();
      API.get(`/index.php?action=getUnits&brand=${context.state.brand}&category=${context.state.selectedCategory}&year=${context.state.selectedYear}&model=${context.state.selectedModel}&color=${context.state.selectedColor}`)
        .then(response => {
          context.commit('setUnits', response.data);
          context.commit('setFilteredUnits', { filter: null });
          context.commit('setUnitsCategories', response.data);
          if (context.state.brand == 'ktm' || context.state.brand == 'husky') {
            localStorage.setItem('selectedCategory', context.state.selectedCategory);
            localStorage.setItem('selectedYear', context.state.selectedYear);
            localStorage.setItem('selectedModel', context.state.selectedModel);

            API.get(`/index.php?action=getCodeByModelDetails&brand=${context.state.brand}&category=${context.state.selectedCategory}&year=${context.state.selectedYear}&model=${context.state.selectedModel}&color=${context.state.selectedColor}`)
              .then(response => {
                localStorage.setItem('selectedCode', response.data.code);
                // Update model filter plugin by sending GET request
                API.get(`https://${location.host}/?model=${response.data.code}&modelname=${context.state.selectedModel}`, { timeout: 15000 })
                  .then(response => { })
                  .catch(error => {
                    console.log(error);
                  });
              })
              .catch(error => {
                console.log(error);
              });
          }
          // loader.hide();
        })
        .catch(error => {
          // loader.hide();
        });
    },
    setFilteredUnits: (context, payload) => {
      context.commit('setFilteredUnits', { filter: payload });
    },
    selectUnit: async (context, payload) => {
      context.commit('setUnit', payload.selectedUnit);
      context.commit('incrementActiveStep');
      let loader = Vue.$loading.show();
      API.get(`/index.php?action=getParts&brand=${context.state.brand}&unit=${context.state.selectedUnit.id}`)
        .then(response => {
          context.commit('setParts', response.data);
          context.commit('setPoints', response.data);
          context.commit('increaseComponentKey');
          loader.hide();
        })
        .catch(error => {
          loader.hide();
        });
    },
    selectUnitFromNav: async (context) => {
      /* Selecion from navbar - mutation of selected unit is already commited, we just need new parts+points */
      let loader = Vue.$loading.show();
      context.commit('setParts', []);
      context.commit('setPoints', []);
      API.get(`/index.php?action=getParts&brand=${context.state.brand}&unit=${context.state.selectedUnit.id}`)
        .then(response => {
          context.commit('setParts', response.data);
          context.commit('setPoints', response.data);
          context.commit('increaseComponentKey');
          loader.hide();
        })
        .catch(error => {
          loader.hide();
        });
    },
    goToNextUnit: (context) => {
      let newIndex;
      for (let i = 0; i < context.state.availableUnits.length; i++) {
        if (context.state.selectedUnit.id == context.state.availableUnits[i].id) {
          newIndex = i + 1;
          if (newIndex <= (context.state.availableUnits.length - 1)) {
            context.commit('setUnit', context.state.availableUnits[newIndex]);
            context.dispatch('selectUnitFromNav');
            break;
          }
        }
      }
    },
    goToPrevUnit: (context) => {
      let newIndex;
      for (let i = 0; i < context.state.availableUnits.length; i++) {
        if (context.state.selectedUnit.id == context.state.availableUnits[i].id) {
          newIndex = i - 1;
          if (newIndex >= 0) {
            context.commit('setUnit', context.state.availableUnits[newIndex]);
            context.dispatch('selectUnitFromNav');
            break;
          }
        }
      }
    },
    mouseOverPoint: (context, payload) => {
      context.commit('setPoint', payload);
      let selectedPart = context.state.parts.find(p => p.figNo == payload.figNo);
      context.commit('setPart', selectedPart);
    },
    setModelByCode: (context) => {
      let code = localStorage.getItem('selectedCode');
      if (code) {
        API.get(`/index.php?action=getModelDetailsByCode&brand=${context.state.brand}&code=${code}`)
          .then(response => {
            if (response.data.found === true) {

              // if (response.data.modelDetails.model !== localStorage.getItem('selectedModel') && response.data.modelDetails.year !== localStorage.getItem('selectedYear')) {
              context.commit('setCategory', response.data.modelDetails.category);
              context.commit('setModel', response.data.modelDetails.model);
              context.commit('setYear', response.data.modelDetails.year);
              context.dispatch('selectColor', { selectedColor: response.data.modelDetails.color });

              context.commit('setActiveStep', 3);
              context.commit('setUnit', {});
              context.commit('setPart', {});
              context.commit('setPoint', {});
              context.commit('setParts', []);
              context.commit('setPoints', []);
              // }
            }
            else {
              context.dispatch('backToCategories');
            }
          });
      }
    },
    searchVIN: (context) => {
      if (context.state.selectedVIN.length > 10) {
        context.dispatch('sendNotification', {
          type: 'info',
          title: i18n.t('message.VINCheckingTitle'),
          text: i18n.t('message.VINCheckingDesc')
        });
        API.get(`/index.php?action=getModelByVIN&brand=${context.state.brand}&vin=${context.state.selectedVIN}`)
          .then(response => {
            if (response.data.found === true) {
              context.dispatch('sendNotification', {
                type: 'success',
                title: i18n.t('message.VINFoundTitle'),
                text: i18n.t('message.VINFoundDesc')
              });
              context.commit('incrementActiveStep');
              if (context.state.brand != 'kawasaki') {
                context.commit('incrementActiveStep');
              }
              // context.commit('incrementActiveStep');

              context.commit('setCategory', response.data.modelDetails.category);
              context.commit('setModel', response.data.modelDetails.model);
              context.commit('setYear', response.data.modelDetails.year);
              // context.commit('setColor', response.data.modelDetails.color);

              if (context.state.brand != 'kawasaki') {
                context.dispatch('selectColor', { selectedColor: response.data.modelDetails.color });
              }
              else {
                context.dispatch('selectModel');
              }
            }
            else {
              context.dispatch('sendNotification', {
                type: 'error',
                title: i18n.t('message.VINNotFoundTitle'),
                text: i18n.t('message.VINNotFoundDesc')
              });
            }
          });
      }
      else {
        context.dispatch('sendNotification', {
          type: 'error',
          title: i18n.t('message.VINIncorrectTitle'),
          text: i18n.t('message.VINIncorrectTitle')
        });
      }
    },
    buy: async (context, payload) => {
      let checkingResponse = {};

      if (context.state.avcLive === false && context.state.avcNative === false) {
        await context.dispatch('addToBasket', { 'SKU': payload.SKU, 'qty': payload.qty, 'name': payload.name, 'slug': payload.slug });
      }
      else {
        if (context.state.avcLive === true) {
          context.dispatch('sendNotification', {
            type: 'info',
            title: i18n.t('message.checkingTitle'),
            text: i18n.t('message.checkingDesc')
          });
          checkingResponse = await API.get(`/index.php?action=checkAvailability&brand=${context.state.brand}&part=${payload.SKU}`);
        }
        else {
          context.dispatch('sendNotification', {
            type: 'info',
            title: i18n.t('message.addingTitle'),
            text: i18n.t('message.addingDesc')
          });
          checkingResponse.data = {};
          checkingResponse.data.checking = false;

        }

        if (checkingResponse.data.checking == false) {
          await context.dispatch('addToBasket', { 'SKU': payload.SKU, 'qty': payload.qty, 'name': payload.name, 'slug': payload.slug });
          context.dispatch('sendNotification', {
            type: 'success',
            title: i18n.t('message.foundFastDeliveryTitle'),
            text: i18n.t('message.foundFastDeliveryDesc')
          });
        }
        else {
          if (checkingResponse.data.part.partFound == true) {

            if (checkingResponse.data.part.minimumQty !== undefined &&
              checkingResponse.data.part.minimumQty != payload.qty &&
              checkingResponse.data.part.minimumQty > payload.qty
            ) {
              payload.qty = checkingResponse.data.part.minimumQty;
              context.dispatch('sendNotification', {
                type: 'info',
                title: i18n.t('message.minimumQuantityTitle'),
                text: i18n.t('message.minimumQuantityDesc')
              });
            }

            if (checkingResponse.data.part.fastDelivery == true) {
              await context.dispatch('addToBasket', { 'SKU': payload.SKU, 'qty': payload.qty, 'name': payload.name, 'slug': payload.slug });
              context.dispatch('sendNotification', {
                type: 'success',
                title: i18n.t('message.foundFastDeliveryTitle'),
                text: i18n.t('message.foundFastDeliveryDesc')
              });
            }
            else {
              await context.dispatch('addToBasket', { 'SKU': payload.SKU, 'qty': payload.qty, 'name': payload.name, 'slug': payload.slug });
              context.dispatch('sendNotification', {
                type: 'warning',
                title: i18n.t('message.foundSlowDeliveryTitle'),
                text: i18n.t('message.foundSlowDeliveryDesc')
              });
            }
          }
          else {
            if (checkingResponse.data.part.replacementPartFound == true) {

              if (checkingResponse.data.part.minimumQty !== undefined &&
                checkingResponse.data.part.minimumQty != payload.qty &&
                checkingResponse.data.part.minimumQty > payload.qty
              ) {
                payload.qty = checkingResponse.data.part.minimumQty;
                context.dispatch('sendNotification', {
                  type: 'info',
                  title: i18n.t('message.minimumQuantityTitle'),
                  text: i18n.t('message.minimumQuantityDesc')
                });
              }

              await context.dispatch('addToBasket', { 'SKU': checkingResponse.data.part.replacementPartNumber, 'qty': payload.qty, 'name': payload.name, 'slug': checkingResponse.data.part.replacementPartSlug });
              context.dispatch('sendNotification', {
                type: 'success',
                title: i18n.t('message.foundReplacementTitle'),
                text: i18n.t('message.foundReplacementDesc')
              });
            }
            else {
              context.dispatch('sendNotification', {
                type: 'error',
                title: i18n.t('message.partNotFoundTitle'),
                text: i18n.t('message.partNotFoundDesc')
              });
            }
          }
        }
      }
    },
    addToBasket: async (context, payload) => {
      switch (Vue.CryptoJS.SHA256(location.host).toString(Vue.CryptoJS.enc.Hex)) {
        case '8b1fdc44bdaf9d6b7bdfa8b474864cbc57467393be4468704626ebab5e3ffea8':
          await context.dispatch('displayPopup', payload);
          return true;
        case '5098747b62c4b507b58b65c75432d1648e654fb4a696113c653d1baf873ddeff':
          await context.dispatch('addToJTLBasketPlugin', payload);
          return true;
        case 'de83ce61e337dc45511ec71d1e080aa5a431e7160544fa3722d38b94f8daba5f':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case 'd404d80e4e98c2529ddf51eec929755894669104f5211923c1abc7876a55c2ed':
          await context.dispatch('addToM2Basket', payload);
          break;
        case 'ea7142a14deaa72238e60efa362998df83a904e0ddf58b209114049014f29317':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case 'b40608d9a3100d69abe529fe9b9c74305e67b75658c2cda5731de1f6d19d2a45':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case 'a805cbc43c3b4ca19750ac3b9a136b31383e176d9b91cab50f38491fcc10adce':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case 'd6aeb77ce95636f42523c4a6b04817a89a4e3d6bd8823e5ff4d4577cd24ef81f':
          await context.dispatch('addToJTLBasketPlugin', payload);
          return true;
        case 'b88d4bdd363194e32db42666bb8d9983cf6968f5385376a6c13776c1253ce68f':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case '6f28313ab0bacfb2f542b1fb704dd29cee9722671f54b1dbd64122708f7e221f':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case '8e35a18f465f5ad5b965f0f114568615adeaef711ff9e826bcd3d73b579f2046':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case '5659aeec7b712b0957e8617525d9ef55ae5dfe9e9f978cfffd45c5368d1dc804':
          await context.dispatch('addToJTLBasketQuickbuy', payload);
          return true;
        case 'e15b947e97479f5e314af0fafc6dccb8a0d934918a980433823face81b108beb':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case '09869992125fcabf40575b5c6547522ce81f341049deb16ad20f7f760baca0d0':
          await context.dispatch('addToJTLBasketPlugin', payload);
          return true;
        case '894d7c730f41ac5d96696741617817405175ed34e14e4bec89f1fb0f098dd733':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case 'd882a8ccf19e935015328d5466fb7396948b34a43aa5ff5e0d196b5bc550c4cf':
          await context.dispatch('addToJTLBasket', payload);
          return true;
        case '487d1e9410d741e35e70dadfef14768cbde872d1a6bce3da129c28909c194b81':
          await context.dispatch('displayPopup', payload);
          return true;
        default:
          return false;
      }
    },
    addToJTLBasket: async (context, payload) => {
      let productURL = null;
      switch (Vue.CryptoJS.SHA256(location.host).toString(Vue.CryptoJS.enc.Hex)) {
        case '8b1fdc44bdaf9d6b7bdfa8b474864cbc57467393be4468704626ebab5e3ffea8':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case '5098747b62c4b507b58b65c75432d1648e654fb4a696113c653d1baf873ddeff':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case 'de83ce61e337dc45511ec71d1e080aa5a431e7160544fa3722d38b94f8daba5f':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case 'ea7142a14deaa72238e60efa362998df83a904e0ddf58b209114049014f29317':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case 'b40608d9a3100d69abe529fe9b9c74305e67b75658c2cda5731de1f6d19d2a45':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case 'a805cbc43c3b4ca19750ac3b9a136b31383e176d9b91cab50f38491fcc10adce':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case 'd6aeb77ce95636f42523c4a6b04817a89a4e3d6bd8823e5ff4d4577cd24ef81f':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case 'b88d4bdd363194e32db42666bb8d9983cf6968f5385376a6c13776c1253ce68f':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case '6f28313ab0bacfb2f542b1fb704dd29cee9722671f54b1dbd64122708f7e221f':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case '8e35a18f465f5ad5b965f0f114568615adeaef711ff9e826bcd3d73b579f2046':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case '5659aeec7b712b0957e8617525d9ef55ae5dfe9e9f978cfffd45c5368d1dc804':
          productURL = `https://${location.host}/${payload.SKU}-teil`;
          break;
        case 'e15b947e97479f5e314af0fafc6dccb8a0d934918a980433823face81b108beb':
          productURL = `https://${location.host}/${payload.slug}`;
          break;
        case '09869992125fcabf40575b5c6547522ce81f341049deb16ad20f7f760baca0d0':
          productURL = `https://${location.host}/${payload.SKU}-teil`;
          break;
        case '894d7c730f41ac5d96696741617817405175ed34e14e4bec89f1fb0f098dd733':
          productURL = `https://${location.host}/${payload.SKU}-teil`;
          break;
        case 'd882a8ccf19e935015328d5466fb7396948b34a43aa5ff5e0d196b5bc550c4cf':
          productURL = `https://${location.host}/${payload.SKU}-teil`;
          break;
      }

      let shopResponse = await API.get(productURL, {
        timeout: 15000
      });

      let doc = new DOMParser().parseFromString(shopResponse.data, 'text/html');
      let articleNumber = doc.body.querySelector('input[name="a"]').value;
      let variantNumber = "";
      let variantName = "";
      let variantValue = "";

      try {
        variantNumber = doc.body.querySelector('input[name="VariKindArtikel"]').value;
        variantName = doc.body.querySelector('select[class="form-control"]').name;
        variantValue = doc.body.querySelector(`option[data-ref="${variantNumber}"]`).value;
      }
      catch (e) { }

      let jtlToken = doc.body.querySelector('input[name="jtl_token"]').value;

      shopResponse = await API.post(productURL,
        `jtl_token=${jtlToken}&a=${articleNumber}&VariKindArtikel=${variantNumber}&${variantName}=${variantValue}&wke=1&show=1&kKundengruppe=1&kSprache=1&anzahl=${payload.qty}&inWarenkorb=In den Warenkorb`,
        {
          timeout: 15000
        });

      $.evo.basket().updateCart();

    },

    addToJTLBasketQuickbuy: async (context, payload) => {
      let shopResponse = await API.get(`https://${location.host}/index.php?k=12`, { timeout: 15000 });

      let doc = new DOMParser().parseFromString(shopResponse.data, 'text/html');
      let jtlToken = doc.body.querySelector('input[name="jtl_token"]').value;

      let ean = payload.SKU.replace(/-/g, '').padEnd(12, '0');

      shopResponse = await API.post(`https://${location.host}/warenkorb.php`,
        `jtl_token=${jtlToken}&schnellkauf=1&ean=${ean}`,
        {
          timeout: 15000
        });

      $.evo.basket().updateCart();

    },

    addToJTLBasketPlugin: async (context, payload) => {
      let shopResponse = await API.get(`https://${location.host}/?ndArtNr=${payload.SKU}&ndAnzahl=${payload.qty}`, { timeout: 15000 });
      $.evo.basket().updateCart();
    },

    addToM2Basket: async (context, payload) => {
      let productURL = null;
      switch (Vue.CryptoJS.SHA256(location.host).toString(Vue.CryptoJS.enc.Hex)) {
        case 'd404d80e4e98c2529ddf51eec929755894669104f5211923c1abc7876a55c2ed':
          productURL = `https://${location.host}/lv/${payload.SKU}.html`;
          break;
      }

      let shopResponse = await API.get(productURL, {
        timeout: 15000
      });

      let doc = new DOMParser().parseFromString(shopResponse.data, 'text/html');

      let productURL2 = doc.body.querySelector(`form[data-product-sku="${payload.SKU}"]`)
        .action;
      let form_key = jQuery.cookie('form_key');
      let item = doc.body.querySelector('input[name="item"]').value;
      let product = doc.body.querySelector('input[name="product"]').value;

      shopResponse = await API.post(productURL2,
        `qty=${payload.qty}&form_key=${form_key}&item=${item}&$product=${product}`,
        {
          timeout: 15000
        });

      reloadMiniCart();

    },

    displayPopup: (context, payload) => {
      console.log(context.state.brand, payload.SKU);
    },

    sendNotification: (context, payload) => {
      Vue.notify({
        group: 'foo',
        type: payload.type,
        title: payload.title,
        text: payload.text,
      })
    }
  },
  plugins: [createPersistedState()],
})
